import React from "react";

import { Col, Row } from "components";

import { TaskOverview } from "pages/admin/verifications/components/misc/TaskOverview";

export const Documents = ({ farmId, farmCountry, farmName }) => (
  <Row>
    <Col>
      <TaskOverview farmId={farmId} farmCountry={farmCountry} farmName={farmName} />
    </Col>
  </Row>
);
